module.exports = __webpack_public_path__ + "img/1.4.4a445cb9.png";